import { isEmpty } from 'lodash'
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import jwt_decode from "jwt-decode";
import { useSelector } from 'react-redux';
function ProtectedRoute({access_level}) {
    const accessCookies = useSelector(state => state.loginSlice)
    const user =  !isEmpty(accessCookies.token) ?  jwt_decode(accessCookies.token) : {accessLevel: 0}
    if (accessCookies.token && access_level > user?.accessLevel) {
        return <Navigate to={-1} />
    }else{
        return !isEmpty(accessCookies.token) ? <Outlet /> : <Navigate to={'/login'} />
    }
}

export default ProtectedRoute